import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowRight, Building2, HardHat, Home, Briefcase, FileCheck, Users, Wrench, PenTool } from 'lucide-react';

export const Services = () => {
  const mainServices = [
    {
      icon: Building2,
      title: 'Promotion Immobilière',
      description: 'Développement et commercialisation de programmes immobiliers résidentiels. De la conception à la livraison, nous gérons l\'ensemble du processus de promotion.',
      features: [
        'Recherche et acquisition foncière',
        'Montage d\'opérations immobilières',
        'Coordination des intervenants',
        'Commercialisation des programmes',
      ],
    },
    {
      icon: HardHat,
      title: 'Construction BTP',
      description: 'Expertise complète dans le secteur du bâtiment et travaux publics. Nous assurons la construction de logements collectifs et individuels avec les plus hauts standards de qualité.',
      features: [
        'Construction de logements collectifs',
        'Maisons individuelles',
        'Rénovation et réhabilitation',
        'Gestion de chantier',
      ],
    },
    {
      icon: Home,
      title: 'Habitat Social',
      description: 'Partenaire privilégié des bailleurs sociaux, nous participons activement à la construction de logements sociaux de qualité, accessibles à tous.',
      features: [
        'Logements locatifs sociaux',
        'Accession sociale à la propriété',
        'Résidences étudiantes',
        'Résidences seniors',
      ],
    },
  ];

  const additionalServices = [
    {
      icon: Briefcase,
      title: 'Maîtrise d\'Ouvrage',
      description: 'Accompagnement complet en tant que maître d\'ouvrage délégué pour vos projets immobiliers.',
    },
    {
      icon: FileCheck,
      title: 'Montage d\'Opérations',
      description: 'Structuration juridique et financière de vos projets de développement immobilier.',
    },
    {
      icon: PenTool,
      title: 'Conception Architecturale',
      description: 'Coordination avec les architectes pour des projets fonctionnels et esthétiques.',
    },
    {
      icon: Wrench,
      title: 'Suivi de Chantier',
      description: 'Contrôle qualité et suivi rigoureux de l\'avancement des travaux.',
    },
    {
      icon: Users,
      title: 'Relations Bailleurs',
      description: 'Interface privilégiée avec les bailleurs sociaux et institutionnels.',
    },
    {
      icon: Building2,
      title: 'Valorisation Foncière',
      description: 'Expertise dans l\'optimisation et la valorisation des terrains.',
    },
  ];

  const process = [
    {
      step: '01',
      title: 'Analyse',
      description: 'Étude approfondie de votre projet et de vos besoins.',
    },
    {
      step: '02',
      title: 'Conception',
      description: 'Définition du programme et coordination architecturale.',
    },
    {
      step: '03',
      title: 'Réalisation',
      description: 'Construction avec suivi qualité et respect des délais.',
    },
    {
      step: '04',
      title: 'Livraison',
      description: 'Remise des clés et accompagnement post-livraison.',
    },
  ];

  return (
    <div data-testid="services-page">
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 lg:pt-40 lg:pb-32 bg-[#F4F4F5]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <p className="text-[#F25F19] font-bold uppercase tracking-widest mb-4">Nos services</p>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-[#0A0A0A] uppercase tracking-tighter leading-tight mb-6">
              Des expertises<br />
              <span className="text-[#F25F19]">sur mesure</span>
            </h1>
            <p className="text-lg md:text-xl text-[#71717A] max-w-xl">
              De la promotion immobilière à la construction, découvrez l'ensemble 
              de nos services dédiés à la réussite de vos projets.
            </p>
          </div>
        </div>
      </section>

      {/* Main Services */}
      <section data-testid="main-services" className="py-20 lg:py-32 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-24">
            {mainServices.map((service, index) => (
              <div
                key={index}
                className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${
                  index % 2 === 1 ? 'lg:flex-row-reverse' : ''
                }`}
              >
                <div className={index % 2 === 1 ? 'lg:order-2' : ''}>
                  <div className="w-16 h-16 bg-[#F25F19] rounded-sm flex items-center justify-center mb-6">
                    <service.icon className="w-8 h-8 text-white" />
                  </div>
                  <h2 className="text-3xl sm:text-4xl font-extrabold tracking-tighter mb-6">
                    {service.title}
                  </h2>
                  <p className="text-[#71717A] text-lg mb-8">
                    {service.description}
                  </p>
                  <ul className="space-y-3 mb-8">
                    {service.features.map((feature, fIndex) => (
                      <li key={fIndex} className="flex items-center gap-3">
                        <div className="w-2 h-2 bg-[#F25F19] rounded-full"></div>
                        <span className="text-[#0A0A0A]">{feature}</span>
                      </li>
                    ))}
                  </ul>
                  <Link to="/contact">
                    <Button
                      className="bg-[#F25F19] hover:bg-[#CC480B] text-white font-bold uppercase tracking-wide px-6 py-3 rounded-sm"
                    >
                      En savoir plus
                      <ArrowRight className="ml-2 w-5 h-5" />
                    </Button>
                  </Link>
                </div>
                <div className={index % 2 === 1 ? 'lg:order-1' : ''}>
                  <div className="relative">
                    <img
                      src={
                        index === 0
                          ? 'https://images.pexels.com/photos/323780/pexels-photo-323780.jpeg?auto=compress&cs=tinysrgb&w=800'
                          : index === 1
                          ? 'https://images.pexels.com/photos/18399901/pexels-photo-18399901.jpeg?auto=compress&cs=tinysrgb&w=800'
                          : 'https://images.pexels.com/photos/2102587/pexels-photo-2102587.jpeg?auto=compress&cs=tinysrgb&w=800'
                      }
                      alt={service.title}
                      className="rounded-sm w-full"
                    />
                    <div className="absolute -bottom-4 -right-4 bg-[#0A0A0A] text-white p-4 rounded-sm">
                      <p className="text-[#F25F19] font-bold mono text-2xl">0{index + 1}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Additional Services */}
      <section data-testid="additional-services" className="py-20 lg:py-32 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <p className="text-[#F25F19] font-bold uppercase tracking-widest mb-4">Expertise complète</p>
            <h2 className="section-title">Services complémentaires</h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {additionalServices.map((service, index) => (
              <div
                key={index}
                className="bg-white p-8 rounded-sm border border-[#E4E4E7] hover:border-[#F25F19] hover:shadow-lg transition-all duration-300 group"
              >
                <service.icon className="w-10 h-10 text-[#F25F19] mb-6" />
                <h3 className="text-xl font-bold tracking-tight mb-4">{service.title}</h3>
                <p className="text-[#71717A]">{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section data-testid="process-section" className="py-20 lg:py-32 bg-[#F4F4F5]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <p className="text-[#F25F19] font-bold uppercase tracking-widest mb-4">Notre méthode</p>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#0A0A0A] tracking-tighter">
              Un processus éprouvé
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {process.map((item, index) => (
              <div key={index} className="relative">
                <div className="bg-white p-8 rounded-sm h-full border border-[#E4E4E7]">
                  <p className="text-[#F25F19] font-bold mono text-5xl mb-4 opacity-50">
                    {item.step}
                  </p>
                  <h3 className="text-xl font-bold text-[#0A0A0A] mb-4">{item.title}</h3>
                  <p className="text-[#71717A]">{item.description}</p>
                </div>
                {index < process.length - 1 && (
                  <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2">
                    <ArrowRight className="w-8 h-8 text-[#F25F19]" />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 lg:py-24 bg-[#0A0A0A]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white tracking-tighter mb-6">
            Besoin d'un accompagnement ?
          </h2>
          <p className="text-white/70 text-lg max-w-2xl mx-auto mb-10">
            Notre équipe d'experts est à votre disposition pour étudier votre projet 
            et vous proposer les solutions adaptées.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Link to="/contact">
              <Button
                data-testid="cta-contact-btn"
                className="bg-[#F25F19] hover:bg-[#CC480B] text-white font-bold uppercase tracking-wide px-8 py-6 text-base rounded-sm"
              >
                Demander un devis
              </Button>
            </Link>
            <a href="tel:0134908690">
              <Button
                variant="outline"
                className="border-white text-white hover:bg-white hover:text-[#0A0A0A] font-bold uppercase tracking-wide px-8 py-6 text-base rounded-sm"
              >
                01.34.90.86.90
              </Button>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
